import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { DispatchProps, OwnProps, StateProps } from './VendorEditScreen';
import VendorEdit from './VendorEditScreen';
import { StoreState } from 'src/store/reducers';
import { getVendor, deleteFileVendor, getFiles, asyncCreateFilesVendor } from 'src/store/actions/vendor-actions';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        vendor: state.vendors.current,
        files: state.vendors.currentFiles,
        inProgress: state.vendors.inProgress,
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getData: (id) => dispatch(getVendor(id)),
        getFiles: (id) => dispatch(getFiles(id)),
        addFiles: async (id, files) => await asyncCreateFilesVendor(id, files, dispatch),
        removeFile: (id) => dispatch(deleteFileVendor(id)),
    };
}

const VendorEditScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(VendorEdit);

export default VendorEditScreen;
